import type { ComponentType } from 'react';
import type { RecruitmentCampaign, RecruitmentTransport } from '@rudi/shared/types/recruitment';

export interface RecruitmentPanelProps {
  draftDirty?: boolean;
  campaign: RecruitmentCampaign;
  transport: RecruitmentTransport;
  onChange: (campaign: RecruitmentCampaign) => void;
}
export interface RecruitmentPanel {
  id: string;
  title: string;
  action: string;
  load: () => Promise<{ default: ComponentType<RecruitmentPanelProps> }>;
}
const panels = new Map<string, RecruitmentPanel>();
export function registerRecruitmentPanel(panel: RecruitmentPanel): void {
  if (panels.has(panel.id)) throw new Error(`Recruitment panel already registered: ${panel.id}`);
  panels.set(panel.id, panel);
}
export function getRecruitmentPanels(actions?: string[]): RecruitmentPanel[] {
  return [...panels.values()]
    .filter(panel => !actions || actions.includes(panel.action))
    .sort((a, b) => Number(b.id === 'readiness') - Number(a.id === 'readiness'));
}
const loadedModules = new Map<() => Promise<{ register: () => void }>, Promise<void>>();
export async function loadRecruitmentPanels(
  modules: Record<string, () => Promise<{ register: () => void }>>
): Promise<void> {
  const errors: Error[] = [];
  for (const [name, load] of Object.entries(modules)) {
    try {
      let loaded = loadedModules.get(load);
      if (!loaded) {
        loaded = load().then(module => module.register());
        loadedModules.set(load, loaded);
      }
      await loaded;
    } catch (cause) {
      loadedModules.delete(load);
      errors.push(new Error(`Recruitment panel failed to load: ${name}`, { cause }));
    }
  }
  if (errors.length) throw new AggregateError(errors, 'Recruitment panels failed to load');
}
